// components/DetailRow.tsx
import React from "react";
import { Box, Typography } from "@mui/material";

interface DetailRowProps {
  label: string;
  value?: string | number | null;
}

const DetailRow: React.FC<DetailRowProps> = ({ label, value }) => {
  return (
    <Box sx={{ mb: 1 }}>
      <Typography
        variant="subtitle2"
        sx={{ fontSize: 12, fontWeight: 700, color: "text.secondary" }}
      >
        {label}
      </Typography>
      <Typography
        variant="body1"
        sx={{ fontSize: 16, fontWeight: 400,
           wordBreak: "break-word",      // allow breaking long words
        overflowWrap: "anywhere",     // extra safety
        whiteSpace: "normal",         // allow wrapping
        lineHeight: 1.4,
         }}
      >
        {value || "-"}
      </Typography>
    </Box>
  );
};

export default DetailRow;
